import styled from '@emotion/styled'
import fp from 'lodash/fp'
import { colors, measures, font, spacing, zIndexes } from 'styles/variables'
import { css } from '@emotion/core'

import { short, long } from '../../styles'

const { unit, half } = measures

export const inlineOptionStyle = css`
  display: flex;
  align-items: center;
  & span {
    padding-left: ${unit}px;
  }
`

export const InlineOptionContainer = styled.div`
  display: flex;
  align-items: center;

  & span {
    padding-left: ${unit}px;
  }
`

export const stylesFn = ({ fluid, showError, styles = {}, size, bordered }) => {
  const borderColor = showError ? colors.errors.error2 : colors.grays.gray7

  const fontStyles = (provided) => ({
    ...provided,
    fontFamily: font.family,
    fontSize: font.size11,
    color: colors.greens.green6,
  })

  return {
    loadingMessage: fontStyles,
    noOptionsMessage: fontStyles,
    option: (provided) => {
      return {
        ...provided,
        fontFamily: font.family,
        fontSize: font.size11,
        color: colors.white100,
        backgroundColor: 'transponent',
        borderBottom: `1px solid ${colors.grays.gray7}`,
        padding: `${spacing(1.5, 2.5)}`,
      }
    },
    menu: (provided) => {
      return {
        ...provided,
        marginTop: 0,
        boxShadow: 'none',
        borderRadius: `${spacing(0, 0, 1.5, 1.5)}`,
        backgroundColor: 'transparent',
        border: bordered ? `1px solid ${colors.grays.gray7}` : 'none',
        zIndex: zIndexes.dropdown,
      }
    },
    menuPortal: (provided) => ({
      ...provided,
      zIndex: zIndexes.dropdown,
    }),
    menuList: (provided) => {
      return {
        ...provided,
        backgroundColor: colors.grays.gray8,
        paddingBottom: 0,
        paddingTop: 0,
        borderRadius: `${spacing(0, 0, 1.5, 1.5)}`,
        maxHeight: unit * 39,
      }
    },
    input: fontStyles,
    singleValue: fontStyles,

    multiValue: (provided) => ({
      ...provided,
      fontFamily: font.family,
      fontSize: font.size11,
      backgroundColor: colors.oranges.orange3,
    }),

    placeholder: (provided) => {
      return {
        ...fontStyles(provided),
        marginLeft: 0,
        fontWeight: font.weight.medium,
        color: colors.white40,
      }
    },

    indicatorsContainer: (provided, state) => ({
      ...provided,
      ...fp.invokeArgs('indicatorsContainer', [state], styles),
    }),

    dropdownIndicator: (provided, state) => ({
      ...provided,
      padding: `${unit}px`,
      cursor: 'pointer',
      ...fp.invokeArgs('dropdownIndicator', [state], styles),
    }),

    clearIndicator: (provided, state) => ({
      ...provided,
      padding: `${half}px`,
      cursor: 'pointer',
      ...fp.invokeArgs('clearIndicator', [state], styles),
    }),

    control: (provided, state) => {
      const backgroundColor = state.isDisabled ? colors.black10 : 'transparent'

      const BRadius = state.menuIsOpen ? spacing(1.5, 1.5, 0, 0) : spacing(1.5)
      const stl = {
        ...provided,
        fontFamily: font.family,
        boxShadow: 'none',
        outline: 'none',
        border: bordered ? `1px solid ${borderColor}` : 'none',
        borderRadius: BRadius,
        backgroundColor,
        minHeight: `${size === 'medium' ? 5 * unit + 8 : 7 * unit - 3}px`,
        minWidth: `${short}px`,
        width: fluid ? '100%' : 'inherit',
        maxWidth: fluid ? '100%' : `${long}px`,
        transition: 'border-color 500ms, background-color 500ms',
        cursor: state.isDisabled ? 'not-allowed' : 'default',
        paddingLeft: unit * 2,
        ':hover': {
          borderColor: colors.greens.green6,
        },

        ...fp.invokeArgs('control', [state], styles),
      }
      if (state.isFocused) {
        stl.border = `1px solid ${borderColor}`
        stl.borderBottom = 'none'
      }
      return stl
    },
  }
}
